import { ICargo } from '@/interfaces/cargo';
import { AxiosResponse } from 'axios';
import {
  IOrder,
  IOrderDDLRes,
  IOrderDriver,
  IOrderPackingList,
  IOrderStatus,
  IOrderSumByDayReq,
  IOrderSumByDayRes,
  IOrderUpdateDocNoReq,
  ISearchOrderReq,
  ISearchOrderRes,
  IVehicleInspection,
} from '../interfaces/order';
import * as baseAdapter from './baseAdapter';

export const queryOrders = async () => {
  const ret = await baseAdapter.get<IOrder[]>('/order');
  return ret;
};

export const getOrder = async (id: number) => {
  const ret = await baseAdapter.get<IOrder>('/order/get/' + id);
  return ret?.data;
};

export const searchOrders = async (req: ISearchOrderReq) => {
  const ret = await baseAdapter.post<ISearchOrderRes>('/order/gets', req);
  return ret;
};

export const addOrder = async (data: Partial<IOrder>) => {
  const ret = await baseAdapter.post<IOrder>('/order/create', data);
  return ret;
};

export const editOrder = async (data: Partial<IOrder>) => {
  const ret = await baseAdapter.put(`/order/update`, data);
  return ret;
};

export const deleteOrder = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/order/deleteOrder/${id}`);
  return ret;
};

export const updateOrderStatus = async (data: IOrderStatus) => {
  const ret = await baseAdapter.post('/order/updateStatus', data);
  return ret;
};

export const getOrderSumByDay = async (data: IOrderSumByDayReq) => {
  const ret = await baseAdapter.post<IOrderSumByDayRes[]>(
    '/order/getordersumbyday',
    data,
  );
  return ret;
};

export const orderPrintCount = async (orderId: number) => {
  const ret = await baseAdapter.put(`/order/printcount/${orderId}`, '');
  return ret;
};

export const orderUpdateDocNo = async (
  orderId: number,
  req: IOrderUpdateDocNoReq,
) => {
  const ret = await baseAdapter.put(`/order/updateDocNo/${orderId}`, req);
  return ret;
};

export const queryCargo = async (numberPlate: string) => {
  const ret = await baseAdapter.get<ICargo[]>(`/order/getCargo/${numberPlate}`);
  return ret;
};

export const validateIvs = async (ivs: string[]) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ret = await baseAdapter.post<any>(`/order/validateIvs`, ivs);
  return ret;
};

export const returnPartialOrder = async (data: Partial<IOrder>) => {
  const ret = await baseAdapter.put(`/order/returnPartialOrder`, data);
  return ret;
};

export const orderDDL = async (data: Partial<ISearchOrderReq>) => {
  const ret = await baseAdapter.post<IOrderDDLRes[]>(`/order/DDL`, data);
  return ret;
};

export const queryOrderPackingList = async (orderNo: string) => {
  const ret = await baseAdapter.get<IOrderPackingList[]>(
    `/order/getPackingList/${orderNo}`,
  );
  return ret;
};

export const patchUpdateDriver = async (data: Partial<IOrderDriver>) => {
  const ret = await baseAdapter.patch(
    `/order/patchUpdateDriver/${data.id}`,
    data,
  );
  return ret;
};

export const getVehicleDetail = async (orderId: number) => {
  const ret = await baseAdapter.get<IVehicleInspection[]>(
    `/order/getVehicleDetail/${orderId}`,
  );
  return ret;
};

export const exportExpressSaleAccount = async (req: ISearchOrderReq) => {
  const ret = await baseAdapter.postDownload<ArrayBuffer>(
    '/order/ExportExpressSaleAccount',
    req,
  );
  return ret as AxiosResponse<ArrayBuffer>;
};
